/* TODO: remove when we have finished verifying new fes policy feature populations
    against their old popstar feature populations.
*/
export function checkFesPolicyAlignment(_a) {
    var popstarFeature = _a.popstarFeature, fesFeature = _a.fesFeature, fesFeatureName = _a.fesFeatureName;
    var fesPolicyMissingFG = popstarFeature.value
        ? !fesFeature.value
        : fesFeature.value;
    var fesPolicyMissingFGLog;
    if (fesPolicyMissingFG) {
        fesPolicyMissingFGLog = {
            fesPolicyName: fesFeatureName,
            missingFeature: popstarFeature.value
                ? fesFeature.name
                : popstarFeature.name
        };
    }
    return { fesPolicyMissingFGLog: fesPolicyMissingFGLog };
}
